import { render, staticRenderFns } from "./iatItem.vue?vue&type=template&id=5ee400e6"
import script from "./iatItem.vue?vue&type=script&lang=js"
export * from "./iatItem.vue?vue&type=script&lang=js"
import style0 from "./iatItem.vue?vue&type=style&index=0&id=5ee400e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports